import { render, staticRenderFns } from "./XlsxViewer.vue?vue&type=template&id=36a38b08&"
import script from "./XlsxViewer.vue?vue&type=script&lang=js&"
export * from "./XlsxViewer.vue?vue&type=script&lang=js&"
import style0 from "./XlsxViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports